import session from '@updater-core/interactors/shell/session';
import createGateway from '@updater-apps/move-your-stuff/gateways/dolly';
import optimizely from '@updater-core/interactors/shell/optimizely';
import createMoveItemsInteractor from '@updater-core/interactors/move-items';
import createDomainTrackerInteractor from '@updater-core/interactors/domain-tracker';
import { createPersistedInteractor } from '@updater-core/interactors/shell/router-persistance';
import { createLogger } from '@updater-apps/move-your-stuff/logger';
import { useInteractor } from '@updater-core/view/hooks/interactor';
import { createGateway as createLocalGateway } from '@updater-core/gateways/local-storage';
import createInteractor from './interactor';
import { MysInteractor } from './types';

const { log } = createLogger('[PERSISTOR]');

const tracker = createDomainTrackerInteractor({ domain: 'mys' });

export default function createMysInteractor(): MysInteractor {
  const dependencies = {
    session,
    optimizely,
    moveItems: createMoveItemsInteractor(),
    gateways: {
      dolly: createGateway({ session }),
      storage: createLocalGateway(),
    },
    tracker,
  };

  const interactor = createPersistedInteractor({
    log,
    persistenceKey: 'upd.mys-interactor',
    createInteractor,
    dependencies,
    basePathRegExp: new RegExp(`/quick-setup/?([^?]*)`),
    onCreated: ({ actions }) => {
      actions.fetchDollyMove();
    },
  });

  return interactor;
}

export function useMysInteractor(): MysInteractor {
  return useInteractor(createMysInteractor);
}
